import React from "react";
import { FormattedMessage } from "react-intl";
import css from "./MergeDuplicateTitles.module.css";
export var titleSourceLabelId = function (source, provisional) {
    if (provisional)
        return "ui-br-legaldeposits.titleMerge.source.provisional";
    if (source === "AGENCY")
        return "ui-br-legaldeposits.titleMerge.source.agency";
    if (source === "SKC")
        return "ui-br-legaldeposits.titleMerge.source.skc";
    return "ui-br-legaldeposits.titleMerge.source.local";
};
export var TitleSourceBadge = function (_a) {
    var source = _a.source, provisional = _a.provisional;
    var variant = provisional
        ? css.sourceProvisional
        : source === "AGENCY"
            ? css.sourceAgency
            : source === "SKC"
                ? css.sourceSkc
                : css.sourceLocal;
    return (React.createElement("span", { className: "".concat(css.sourceBadge, " ").concat(variant) },
        React.createElement(FormattedMessage, { id: titleSourceLabelId(source, provisional) })));
};
